import { File, FileText, User } from "@phosphor-icons/react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { buttonVariants } from "./button";

const BuilderNavigator = () => {
  const currentPath = window.location.pathname;

  const items = useMemo(
    () => [
      {
        label: "Petitions",
        icon: FileText,
        path: "/admin/petition-builder",
      },
      {
        label: "Entities",
        icon: User,
        path: "/admin/entities",
      },
      {
        label: "Exhibit Repo",
        icon: File,
        path: "/admin/exhibit-repo",
      },
    ],
    []
  );

  return (
    <div className="w-full flex flex-row border-b items-center px-3 pb-2 gap-x-2">
      {items.map((item) => (
        <Link
          className={`flex flex-row gap-x-1 ${
            currentPath.startsWith(item.path)
              ? buttonVariants({ variant: "tab-active", size: "tab" })
              : buttonVariants({ variant: "tab", size: "tab" })
          }`}
          to={item.path}
          key={item.path}
        >
          <item.icon size={14} /> {item.label}
        </Link>
      ))}
    </div>
  );
};

export default BuilderNavigator;
